import { render, staticRenderFns } from "./BatchNotificationForm.vue?vue&type=template&id=01a14266"
import script from "./BatchNotificationForm.vue?vue&type=script&lang=js"
export * from "./BatchNotificationForm.vue?vue&type=script&lang=js"
import style0 from "./BatchNotificationForm.vue?vue&type=style&index=0&id=01a14266&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports